import React from "react";
import future from "./introimages/future.png";
import "./intro.css";
import databaseManager from "../../../databaseManager";

const Introsec7 = () => {
  return (
    <>
      <div className="introsec7-container">
        <h2>Building a Future with Ethical AI</h2>
        <div className="img-container">
          <img src={future} alt="future-of-AI-img" />
        </div>
        <p>
          To ensure that AI benefits society, it is essential to establish clear
          ethical guidelines and frameworks for its development and use.
          Governments, industry leaders, and researchers must collaborate to
          create policies that promote fairness, transparency, and
          accountability in AI systems. These policies should address the
          potential risks associated with AI while also fostering innovation. In
          addition, AI developers must take responsibility for the technologies
          they create by conducting thorough testing and ensuring that their
          systems are designed with ethical principles in mind.
        </p>
        <p>
          In conclusion, the impact of AI ethics on society cannot be
          overstated. When ethical guidelines are followed, AI has the potential
          to drive innovation and improve lives across various sectors,
          including healthcare, education, and environmental sustainability.
          However, neglecting these considerations can lead to biased outcomes,
          data breaches, and a loss of public trust. By prioritizing ethical AI
          development, we can harness the full potential of this powerful
          technology while ensuring that it serves the public good.{" "}
        </p>
      </div>
    </>
  );
};

export default Introsec7;
